import React from 'react';

const LogoSlack = ({ className = "w-12 h-12" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="12" fill="#E01E5A"/>
    <path d="M15 14H20C21.1046 14 22 14.8954 22 16V20H17C15.8954 20 15 19.1046 15 18V14Z" fill="white"/>
    <path d="M28 15H33C34.1046 15 35 15.8954 35 17V22H28V15Z" fill="white"/>
    <path d="M33 28H28C26.8954 28 26 27.1046 26 26V22H31C32.1046 22 33 22.8954 33 24V28Z" fill="white"/>
    <path d="M20 27H15C13.8954 27 13 26.1046 13 25V20H18C19.1046 20 20 20.8954 20 22V27Z" fill="white"/>
  </svg>
);

export default LogoSlack;
